/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outside_Point_1Inputs */

const en_outside_point_1 = /** @type {(inputs: Outside_Point_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stock is read from the IMS, never kept twice`)
};

/**
* | output |
* | --- |
* | "Stock is read from the IMS, never kept twice" |
*
* @param {Outside_Point_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const outside_point_1 = /** @type {((inputs?: Outside_Point_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outside_Point_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_outside_point_1(inputs)
});